import { Alert, Drawer, Tabs } from '@silverfort/sf-components';
import { useSmartPolicyContext } from '../SmartPolicyContext';
import { useState } from 'react';
import ScopeTab from './ScopeTab/ScopeTab';
import ActionsTab from './ActionsTab/ActionsTab';
import useHasPermissions from '../../../../../../hooks/useHasPermissions';
import { Pages, Roles } from '../../../../../../context/contexts/UserContext/permissionsTypes';

const TABS = {
    SCOPE: { value: 1, name: 'Scope' },
    ACTIONS: { value: 2, name: 'Policies' }
};

const SmartPolicyDrawer = () => {
    const { smartPolicyForEdit, setSmartPolicyForEdit, isPolicyForEditValid, saveSmartPolicy } =
        useSmartPolicyContext();
    const [selectedTab, setSelectedTab] = useState(TABS.SCOPE.value);
    const isEditor = useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.EDITOR });

    const isEditingExisting = smartPolicyForEdit && smartPolicyForEdit.id > 0;

    return (
        <Drawer
            open={!!smartPolicyForEdit}
            onClose={() => {
                setSelectedTab(TABS.SCOPE.value);
                setSmartPolicyForEdit();
            }}
            onAction={saveSmartPolicy}
            footerActionTitle="Save"
            footerActionProps={{
                disabled: !isPolicyForEditValid || !isEditor,
                tooltip: isPolicyForEditValid ? undefined : { title: 'Required fields missing' }
            }}
            footerCloseTitle="Cancel"
            headerTitle={isEditingExisting ? 'Edit Smart Policy Rule' : 'Create Smart Policy Rule'}
            headerDescription={isEditingExisting ? `ID: ${smartPolicyForEdit.id}` : undefined}>
            <div className="w-[494px]">
                <Tabs onClick={(tab) => setSelectedTab(tab)} selectedTab={selectedTab} tabs={Object.values(TABS)} />
                <div className="py-4">
                    {selectedTab === TABS.SCOPE.value && <ScopeTab />}
                    {selectedTab === TABS.ACTIONS.value && <ActionsTab />}
                </div>
                <Alert />
            </div>
        </Drawer>
    );
};

export default SmartPolicyDrawer;
